<template>
  <div>
    <ForeignOrganization :v="v" />

    <v-row>
      <v-col cols="12">
        <MrpaTrustee
          :v="v.trustee"
          label="Сведения о представителе иностранного юридического лица"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import cloneDeep from 'clone-deep';
import { FieldName } from '@/constants';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from '@/components/services/EgrnConfirm/Applicant/components/ForeignOrganization';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import deepmerge from 'deepmerge';

export const mrpaForeignOrganizationModel = deepmerge(
  foreignOrganizationModel,
  {
    trustee: cloneDeep(mrpaTrusteeModel),
  }
);

export const getMrpaForeignOrganizationValidation = (foreignOrganization) => ({
  ...foreignOrganizationValidation,
  trustee: getMrpaTrusteeValidation(foreignOrganization.trustee),
});

export default {
  name: 'MrpaForeignOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    ForeignOrganization,
    MrpaTrustee,
  },
  data: () => ({
    getValidationErrorText,
    FieldName,
  }),
};
</script>
